import { MathFormula } from './Math'
import {
    VerifyNumericLimit_Btw_MinMax,
    VerifyNumericLimit_ByLimit,
    RoundValueASTM,
    RoundValueASTM_ValAsStr,
    Approximates,
    RemoveScientificNotation,
    GetDecimalsFromString,
    VpsCommodity,
    VpsGravityType,
    VpsTemperatureUnit,
    VpsQuantityUnit
} from './FuelMath';
import { rest } from 'underscore';
export class Co2service {

    static response = {
        Co2TextBox: ""
    };
    static Co2Combustion(val) {
        return MathFormula.RoundValueASTM(val, 0.001)

    }
    ;
    static CalculateCo2(config) {
        
        let result = {};

        let C3 = config.MCR_mainengine;
        let D3 = config.Actualload_mainengine;
        let C4 = config.MCR_AE1;
        let D4 = config.Actualload_AE1;
        let C5 = config.MCR_AE2;
        let D5 = config.Actualload_AE2;
        let C6 = config.MCR_AE3;
        let D6 = config.Actualload_AE3;
        let ActualFOconsumed_mainengine = parseFloat(config.ActualFOconsumed_mainengine);
        let ActualFOconsumed_AE1 = parseFloat(config.ActualFOconsumed_AE1);
        let ActualFOconsumed_AE2 = parseFloat(config.ActualFOconsumed_AE2);
        let ActualFOconsumed_AE3 = parseFloat(config.ActualFOconsumed_AE3);
        let TotalMinutes = config.TotalMinutes;
        // let CO2basedonAnnex = 3.188;
        // CO2basedonAnnex_Vlsfo
        let ACR_mainengine = RoundValueASTM(((D3 / C3) * 100), 0.1);
        let ACR_AE1 = RoundValueASTM(((D4 / C4) * 100), 0.1);
        let ACR_AE2 = RoundValueASTM(((D5 / C5) * 100), 0.1);
        let ACR_AE3 = RoundValueASTM(((D6 / C6) * 100), 0.1);
        result.ACR_mainengine = ACR_mainengine;
        result.ACR_AE1 = ACR_AE1;
        result.ACR_AE2 = ACR_AE2;
        result.ACR_AE3 = ACR_AE3;


        let ExpectedFO_mainengine = parseFloat(RoundValueASTM((((config.FOcon_mainengine * D3) * (TotalMinutes / 60) / 1000000) * 100), 0.1));
        let ExpectedFO_AE1 = parseFloat(RoundValueASTM((((config.FOcon_AE1 * D4) * (TotalMinutes / 60) / 1000000) * 100), 0.1));
        let ExpectedFO_AE2 = parseFloat(RoundValueASTM((((config.FOcon_AE2 * D5) * (TotalMinutes / 60) / 1000000) * 100), 0.1));
        let ExpectedFO_AE3 = parseFloat(RoundValueASTM((((config.FOcon_AE3 * D6) * (TotalMinutes / 60) / 1000000) * 100), 0.1));
        result.ExpectedFO_mainengine = ExpectedFO_mainengine;
        result.ExpectedFO_AE1 = ExpectedFO_AE1;
        result.ExpectedFO_AE2 = ExpectedFO_AE2;
        result.ExpectedFO_AE3 = ExpectedFO_AE3;


        let Total_ActualFOconsumed = (ActualFOconsumed_mainengine + ActualFOconsumed_AE1 + ActualFOconsumed_AE2 + ActualFOconsumed_AE3);
        result.Total_ActualFOconsumed = Total_ActualFOconsumed;
        let Total_ExpectedFO = (ExpectedFO_mainengine + ExpectedFO_AE1 + ExpectedFO_AE2 + ExpectedFO_AE3) / 100;
        result.Total_ExpectedFO = Total_ExpectedFO;

        let CO2_Emissions_Actaul = (Total_ActualFOconsumed * config.CO2basedonAnnex_Vlsfo).toFixed(2);
        result.CO2_Emissions_Actaul = CO2_Emissions_Actaul;

        let CO2_Emissions_High_CV_fuel = (Total_ExpectedFO * config.CO2basedonAnnex_Vlsfo).toFixed(2);
        result.CO2_Emissions_High_CV_fuel = CO2_Emissions_High_CV_fuel;

        let Excess_CO2 = (CO2_Emissions_Actaul - CO2_Emissions_High_CV_fuel).toFixed(2);
        result.Excess_CO2 = Excess_CO2;

        return result
    }
    static CalculateMgo(config) {
        ;
        let mgoresult = {};

        let C3 = config.MCR_mainengine;
        let D3 = config.Actualload_mainengine;
        let C4 = config.MCR_AE1;
        let D4 = config.Actualload_AE1;
        let C5 = config.MCR_AE2;
        let D5 = config.Actualload_AE2;
        let C6 = config.MCR_AE3;
        let D6 = config.Actualload_AE3;
        let ActualFOconsumed_mainengine = parseFloat(config.ActualFOconsumed_mainengine);
        let ActualFOconsumed_AE1 = parseFloat(config.ActualFOconsumed_AE1);
        let ActualFOconsumed_AE2 = parseFloat(config.ActualFOconsumed_AE2);
        let ActualFOconsumed_AE3 = parseFloat(config.ActualFOconsumed_AE3);
        let TotalMinutes = config.TotalMinutes;
        // let CO2basedonAnnex = 3.206;
        // CO2basedonAnnex_Mgo
        let ACR_mainengine = RoundValueASTM(((D3 / C3) * 100), 0.1);
        let ACR_AE1 = RoundValueASTM(((D4 / C4) * 100), 0.1);
        let ACR_AE2 = RoundValueASTM(((D5 / C5) * 100), 0.1);
        let ACR_AE3 = RoundValueASTM(((D6 / C6) * 100), 0.1);
        mgoresult.ACR_mainengine = ACR_mainengine;
        mgoresult.ACR_AE1 = ACR_AE1;
        mgoresult.ACR_AE2 = ACR_AE2;
        mgoresult.ACR_AE3 = ACR_AE3;

        let ExpectedFO_mainengine = parseFloat(RoundValueASTM((((config.FOcon_mainengine * D3) * (TotalMinutes / 60) / 1000000) * 100), 0.1));
        let ExpectedFO_AE1 = parseFloat(RoundValueASTM((((config.FOcon_AE1 * D4) * (TotalMinutes / 60) / 1000000) * 100), 0.1));
        let ExpectedFO_AE2 = parseFloat(RoundValueASTM((((config.FOcon_AE2 * D5) * (TotalMinutes / 60) / 1000000) * 100), 0.1));
        let ExpectedFO_AE3 = parseFloat(RoundValueASTM((((config.FOcon_AE3 * D6) * (TotalMinutes / 60) / 1000000) * 100), 0.1));
        mgoresult.ExpectedFO_mainengine = ExpectedFO_mainengine;
        mgoresult.ExpectedFO_AE1 = ExpectedFO_AE1;
        mgoresult.ExpectedFO_AE2 = ExpectedFO_AE2;
        mgoresult.ExpectedFO_AE3 = ExpectedFO_AE3;


        let Total_ActualFOconsumed = (ActualFOconsumed_mainengine + ActualFOconsumed_AE1 + ActualFOconsumed_AE2 + ActualFOconsumed_AE3);
        mgoresult.Total_ActualFOconsumed = Total_ActualFOconsumed;
        let Total_ExpectedFO = (ExpectedFO_mainengine + ExpectedFO_AE1 + ExpectedFO_AE2 + ExpectedFO_AE3) / 100;
        mgoresult.Total_ExpectedFO = Total_ExpectedFO;

        let CO2_Emissions_Actaul = (Total_ActualFOconsumed * config.CO2basedonAnnex_Mgo).toFixed(2);
        mgoresult.CO2_Emissions_Actaul = CO2_Emissions_Actaul;

        let CO2_Emissions_High_CV_fuel = (Total_ExpectedFO *  config.CO2basedonAnnex_Mgo).toFixed(2);
        mgoresult.CO2_Emissions_High_CV_fuel = CO2_Emissions_High_CV_fuel;

        let Excess_CO2 = (CO2_Emissions_Actaul - CO2_Emissions_High_CV_fuel).toFixed(2);
        mgoresult.Excess_CO2 = Excess_CO2;


        return mgoresult
    }
    static CalculateLng(config) {
        ;
        let lngresult = {};

        let C3 = config.MCR_mainengine;
        let D3 = config.Actualload_mainengine;
        let C4 = config.MCR_AE1;
        let D4 = config.Actualload_AE1;
        let C5 = config.MCR_AE2;
        let D5 = config.Actualload_AE2;
        let C6 = config.MCR_AE3;
        let D6 = config.Actualload_AE3;
        let ActualFOconsumed_mainengine = parseFloat(config.ActualFOconsumed_mainengine);
        let ActualFOconsumed_AE1 = parseFloat(config.ActualFOconsumed_AE1);
        let ActualFOconsumed_AE2 = parseFloat(config.ActualFOconsumed_AE2);
        let ActualFOconsumed_AE3 = parseFloat(config.ActualFOconsumed_AE3);
        let TotalMinutes = config.TotalMinutes;
        // let CO2basedonAnnex = 3.206;
        // CO2basedonAnnex_Mgo
        let ACR_mainengine = RoundValueASTM(((D3 / C3) * 100), 0.1);
        let ACR_AE1 = RoundValueASTM(((D4 / C4) * 100), 0.1);
        let ACR_AE2 = RoundValueASTM(((D5 / C5) * 100), 0.1);
        let ACR_AE3 = RoundValueASTM(((D6 / C6) * 100), 0.1);
        lngresult.ACR_mainengine = ACR_mainengine;
        lngresult.ACR_AE1 = ACR_AE1;
        lngresult.ACR_AE2 = ACR_AE2;
        lngresult.ACR_AE3 = ACR_AE3;

        let ExpectedFO_mainengine = parseFloat(RoundValueASTM((((config.FOcon_mainengine * D3) * (TotalMinutes / 60) / 1000000) * 100), 0.1));
        let ExpectedFO_AE1 = parseFloat(RoundValueASTM((((config.FOcon_AE1 * D4) * (TotalMinutes / 60) / 1000000) * 100), 0.1));
        let ExpectedFO_AE2 = parseFloat(RoundValueASTM((((config.FOcon_AE2 * D5) * (TotalMinutes / 60) / 1000000) * 100), 0.1));
        let ExpectedFO_AE3 = parseFloat(RoundValueASTM((((config.FOcon_AE3 * D6) * (TotalMinutes / 60) / 1000000) * 100), 0.1));
        lngresult.ExpectedFO_mainengine = ExpectedFO_mainengine;
        lngresult.ExpectedFO_AE1 = ExpectedFO_AE1;
        lngresult.ExpectedFO_AE2 = ExpectedFO_AE2;
        lngresult.ExpectedFO_AE3 = ExpectedFO_AE3;


        let Total_ActualFOconsumed = (ActualFOconsumed_mainengine + ActualFOconsumed_AE1 + ActualFOconsumed_AE2 + ActualFOconsumed_AE3);
        lngresult.Total_ActualFOconsumed = Total_ActualFOconsumed;
        let Total_ExpectedFO = (ExpectedFO_mainengine + ExpectedFO_AE1 + ExpectedFO_AE2 + ExpectedFO_AE3) / 100;
        lngresult.Total_ExpectedFO = Total_ExpectedFO;

        let CO2_Emissions_Actaul = (Total_ActualFOconsumed * config.CO2basedonAnnex_Lng).toFixed(2);
        lngresult.CO2_Emissions_Actaul = CO2_Emissions_Actaul;

        let CO2_Emissions_High_CV_fuel = (Total_ExpectedFO *  config.CO2basedonAnnex_Lng).toFixed(2);
        lngresult.CO2_Emissions_High_CV_fuel = CO2_Emissions_High_CV_fuel;

        let Excess_CO2 = (CO2_Emissions_Actaul - CO2_Emissions_High_CV_fuel).toFixed(2);
        lngresult.Excess_CO2 = Excess_CO2;


        return lngresult
    }

}